import "./styles.scss";
import { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { mask, unMask } from "remask";
import { Api } from "../../services/Api";
import ValidaCNPJ from "../../utils/ValidaCNPJ";
import ValidaCPF from "../../utils/ValidaCPF";
import { toast } from "react-toastify";
import { useInfo } from "../../context/GeneralInfoContext";
import { login } from "../../services/Auth";
import { useNavigate } from "react-router-dom";
import { format, parse } from "date-fns";
import SimpleLoading from "../../components/SimpleLoading";
import mourapalha from "../../assets/mourapalha.png";
import mourapalhaWL from "../../assets/whitelabel-mourapalha.png";
import manaus6 from "../../assets/cartorio6manaus.png";
import manaus6logo from "../../assets/cartorio6manausLogo.png";
import genericoLogo from "../../assets/logo_cartorio_pague-03.svg"
import newPick from "../../assets/leftSide.png";
import logoMarcaFortaleza from "../../assets/logoFortaleza.png";

// import { Dialog } from 'primereact/dialog';
// import QRCode from 'qrcode.react';
//import paguelogo from 'Pague_Direto_Marca-01.png';

function Login() {
  const navigate = useNavigate();
  const { today } = useInfo();
  const [checked, setChecked] = useState(false);
  const [documento, setDocumento] = useState("");
  const [dataNascimento, setDataNascimento] = useState();
  const [loading, setLoading] = useState(false);

  const myArray = [1, 2, 3];

  function relogio() {
    if (Number(format(today, "k")) < 12) return "Bom dia";
    if (Number(format(today, "k")) < 19) return "Boa tarde";
    if (Number(format(today, "k")) < 5 || Number(format(today, "k")) >= 19)
      return "Boa noite";
  }

  for (let i = 0; i < myArray.length; i++) {}

  const entrar = async (event) => {
    event.preventDefault();
    console.log(parse(dataNascimento,'dd/MM/yyyy',new Date()))
    const DocValido = validarDocumento(unMask(documento));
    const DataValida = validarData(parse(dataNascimento,'dd/MM/yyyy',new Date()));
    if (DataValida) {
      if (DocValido) {
        setLoading(true);
        try {
          const { data } = await Api.post("/login/generica", {
            cpf: unMask(documento),
            data_nascimento: format(parse(dataNascimento,'dd/MM/yyyy',new Date()), "yyyy-MM-dd"),
          });
          login(data.token);
          navigate("/dashboard");
        } catch (error) {
          console.error(error);
          if (error.response === undefined)
            return toast.error("Erro de conexão com o servidor!");
          if (error.response.status === 401)
            return toast.error(
              "Cliente não encontrado com essa combinação de documento e data"
            );
        } finally {
          setLoading(false);
        }
      } else toast.error("Insira um CPF/CNPJ válido!");
    } else toast.error("Data inválida!");
  };

  function validarDocumento(documento) {
    if (documento.length === 11) return ValidaCPF(documento);
    if (documento.length === 14) return ValidaCNPJ(documento);
    else return false;
  }

  function validarData(data) {
    if (data < today) return true;
    else return false;
  }

  return (
    <>
      <SimpleLoading status={loading} />
      <div className="min-h-screen h-full w-screen flex mt-[6vh] lg:mt-0" 
      // style={window.location.host !== 
      //   "protesto.paguedireto.com.br" ? {background:"linear-gradient(338deg, rgba(28,83,100,1) 35%, rgba(58,140,81,1) 100%)"}
      //   : {background: "#4e5c61"}}
        >
        <div className="w-3/5 h-full">
          {window.location.host === "1cartoriodefortaleza.paguedireto.com.br" ? (
            <div className="h-screen w-screen flex align-start bg-gradient-to-tl from-black to-stone-400">
              <img src={newPick} alt="LogoMarca" className="hidden lg:flex " />
            </div>
          ) : (
            <div >
              {window.location.host === "6protestomanaus.paguedireto.com.br" ?
              <div className="h-screen w-screen flex bg-[#4e5c61] md:bg-center align-start">
                <img src={manaus6} alt="LogoMarca" className="hidden lg:flex " />
              </div> 
              : 
              <div className="h-screen w-screen flex md:bg-center align-start"
              style ={{background:"linear-gradient(338deg, rgba(28,83,100,1) 35%, rgba(58,140,81,1) 100%)"}}>
                <img src={mourapalhaWL} alt="LogoMarca" className="hidden lg:flex " />
              </div>  
              }

            </div>
          )}
        </div>
       
        <div
          className=" h-full
     w-full lg:w-1/2 right-0 absolute font-branding"
        >
          <div className=" justify-center p-4 
          items-center flex gap-[4vh] flex-col h-screen sm:p-4 -mt-[4vh] "
          >
            <div className="p-4">
              {window.location.host ===
              "1cartoriodefortaleza.paguedireto.com.br" ? (
                <div className="logoMarca flex align-center justify-center ">
                  <img
                    src={logoMarcaFortaleza}
                    alt="Imagem da frente do cartório de Fortaleza"
                  />
                </div>
              ) : (
                <div >
                  {window.location.host ===
                  "6protestomanaus.paguedireto.com.br" ? (
                    <div className=" flex align-center justify-center ">
                      <img
                        src={manaus6logo}
                        alt="Imagem da frente do cartório de Manaus"
                      />
                    </div>
                  ) : (
                    <div className="lg:w-[50vh] lg:-mb-[12vh] lg:-mt-[12vh] 
                    w-[25vh] -mb-[10vh] -mt-[10vh] 
                    flex align-center justify-center">
                      <img className="mb-3" src={genericoLogo} alt="direto-logo" />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              className="card w-full md:w-2/3 text-slate-700 
             p-7 md:p-10 bg-gray-100"
            >
              <form onSubmit={(e) => entrar(e)}>
                <div className="mb-3 font-branding-bold">
                  <h5>
                    {relogio()}! Para consultar suas taxas e emolumentos devidos
                    ao cartório, digite os dados abaixo{" "}
                  </h5>
                </div>
                <div>
                  <h6>CPF/ CNPJ</h6>
                  <InputText
                    id="documento"
                    type="text"
                    //    aria-errormessage='CPF/CNPJ Vazio!'

                    placeholder="ex: 999.999.999-99"
                    value={documento}
                    onChange={({ target }) => {
                      setDocumento(
                        mask(unMask(target.value), [
                          "999.999.999-99",
                          "99.999.999/9999-99",
                        ])
                      );
                    }}
                  />
                </div>
                <div className="loginCalendar">
                  <h6>Data de Nascimento/ Criação da Empresa</h6>
                  <InputText
                    id="datanascimento"
                    type='text'
                    placeholder="ex: 21/06/1992"
                    value={dataNascimento}
                    onChange={({ target }) =>{
                        setDataNascimento(
                            mask(unMask(target.value), [
                                '99/99/9999',
                            ]) 
                            )
                        }}
                    />
                </div>
                <div className="loginCheckbox mt-4 font-branding">
                  <Checkbox
                    className="loginCheckbox"
                    onChange={(e) => setChecked(e.checked)}
                    checked={checked}
                  />
                  <label>
                    Li e aceito os
                    <a
                      className="text-blue-600"
                      href="/Política_de_Privacidade_Direto_TechV1.pdf"
                      target="_blank"
                      rel="noopener noreferer"
                    >
                      &nbsp;Termos de Uso e Política de Privacidade
                    </a>
                  </label>
                </div>
                <div className="loginButton mt-8">
                  <Button
                    label="Consulte"
                    style={{fontFamily:'Branding-Regular, serif'}}
                    disabled={!checked}
                    type="submit"
                  ></Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
